(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7522],{

/***/ 28631:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ BCCDatePicker; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(77349);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(42298);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(61155);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(61436);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(68239);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(22430);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(61903);
/* harmony import */ var _react_hook_window_size__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(61715);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _mui_icons_material_DateRange__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(21075);
/* harmony import */ var _FlightSearchDate_module_scss__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(63110);
/* harmony import */ var _FlightSearchDate_module_scss__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_FlightSearchDate_module_scss__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _mobiscroll_datepicker_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46164);









var pickerTheme = (0,_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
    shape: {
        borderRadius: 12
    },
    palette: {
        primary: {
            main: "#0a0a0a"
        }
    },
    typography: {
        fontFamily: '"Libre Franklin", sans-serif'
    }
});
var BCCDatePicker = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.memo)(function(param) {
    var labelStart = param.labelStart, labelEnd = param.labelEnd, name = param.name, setFieldValue = param.setFieldValue, _mode = param.mode, mode = _mode === void 0 ? "single" : _mode, _viewMode = param.viewMode, viewMode = _viewMode === void 0 ? "vertical" : _viewMode, error = param.error, value = param.value, rangeValue = param.rangeValue, _rangeLimitation = param.// allowSameDateSelection = true,
    rangeLimitation, rangeLimitation = _rangeLimitation === void 0 ? 360 : _rangeLimitation, _maxDate = param.maxDate, maxDate = _maxDate === void 0 ? (0,date_fns__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(new Date(), rangeLimitation) : _maxDate, _minDate = param.minDate, minDate = _minDate === void 0 ? (0,date_fns__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(new Date(), "yyyy-MM-dd") : _minDate, _errorMessages = param.errorMessages, errorMessages = _errorMessages === void 0 ? null : _errorMessages, _primaryColor = param.primaryColor, primaryColor = _primaryColor === void 0 ? "#00454A" : _primaryColor, allowPast = param.allowPast, maxRange = param.maxRange;
    var rangeHeader = function rangeHeader() {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "w-full",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: "text-xs text-green-400",
                    children: "*Select your travel period. Click on month label to change the mode to month view"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "flex w-full",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mobiscroll_datepicker_react__WEBPACK_IMPORTED_MODULE_3__/* .CalendarPrev */ .Ls, {}),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mobiscroll_datepicker_react__WEBPACK_IMPORTED_MODULE_3__/* .CalendarNav */ .gW, {
                            className: "flex w-full items-center flex-auto"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mobiscroll_datepicker_react__WEBPACK_IMPORTED_MODULE_3__/* .CalendarNext */ .vV, {})
                    ]
                })
            ]
        });
    };
    var inputTheme = (0,_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        shape: {
            borderRadius: 12,
            paddingRight: 0
        },
        palette: {
            primary: {
                main: primaryColor
            }
        },
        typography: {
            fontFamily: '"Libre Franklin", sans-serif'
        }
    });
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([
        null,
        null
    ]), valueRange = ref[0], setValueRange = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([
        null,
        null, 
    ]), valueRangeFormatted = ref1[0], setValueRangeFormatted = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(value ? (0,date_fns__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,date_fns__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(value, "yyyy-MM-dd", new Date()), "E, dd MMM") : null), dateValueFormatted = ref2[0], setDateValueFormatted = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), patched = ref3[0], setPatched = ref3[1];
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(value), dateValue = ref4[0], setValue = ref4[1];
    var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), open = ref5[0], setOpen = ref5[1];
    var ref6 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), singleOpen = ref6[0], setSingleOpen = ref6[1];
    var width = (0,_react_hook_window_size__WEBPACK_IMPORTED_MODULE_8__/* .useWindowWidth */ .Lm)();
    var ref7 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(null), start = ref7[0], startRef = ref7[1];
    // function getLang() {
    //   if (navigator.languages != undefined) return navigator.languages[0];
    //   return navigator.language;
    // }
    var ref8 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(null), end = ref8[0], endRef = ref8[1];
    var ref9 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(null), single = ref9[0], singleRef = ref9[1];
    var ref10 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(null), firstDayOfTheWeek = ref10[0], setFirstDayOfTheWeek = ref10[1];
    var ref11 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(null), activeInput = ref11[0], setActiveInput = ref11[1];
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (!patched && rangeValue && rangeValue[0] && rangeValue[1]) {
            var parsed = [
                (0,date_fns__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(rangeValue[0], "yyyy-MM-dd", new Date()),
                (0,date_fns__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(rangeValue[1], "yyyy-MM-dd", new Date()), 
            ];
            setValueRange(parsed);
            setValueRangeFormatted([
                (0,date_fns__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(parsed[0], "E, dd MMM"),
                (0,date_fns__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(parsed[1], "E, dd MMM"), 
            ]);
        // setPatched(true); // It not updated on change for DealsDialog, could break smth enywhere?
        }
    }, [
        rangeValue
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (!patched && value) {
            var parsed = (0,date_fns__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(value, "yyyy-MM-dd", new Date());
            setValue(parsed);
            setDateValueFormatted((0,date_fns__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(parsed, "E, dd MMM"));
            setPatched(true);
        }
    }, [
        value
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        // const firstDayOfWeek = getFirstDayOfWeek();
        setFirstDayOfTheWeek(firstDayOfTheWeek);
    }, []);
    // function getFirstDayOfWeek() {
    //   // todo improve this logic
    //   let firstDay;
    //   try {
    //     // Ensure that navigator.language or navigator.languages[0] provides a valid BCP 47 language tag
    //     const locale =
    //       void 0 !== navigator.languages && navigator.languages.length > 0
    //         ? navigator.languages[0]
    //         : navigator.language;
    //
    //     // Check for Intl.Locale and its weekInfo support
    //     if (Intl.Locale && typeof Intl.Locale.prototype === 'object') {
    //       const localeObj = new Intl.Locale(locale);
    //       if (
    //         localeObj.weekInfo &&
    //         typeof localeObj.weekInfo.firstDay === 'number'
    //       ) {
    //         firstDay = localeObj.weekInfo.firstDay;
    //       }
    //     }
    //   } catch (error) {
    //     console.error('Error determining first day of the week:', error);
    //     // Apply fallback or default value
    //   }
    //
    //   // If the weekInfo or firstDay wasn't accessible or valid, use a fallback
    //   if (typeof firstDay !== 'number') {
    //     console.warn('Using fallback for first day of the week.');
    //     // You may need to hardcode this or provide a default based on typical locale assumptions
    //     firstDay = 1; // Assuming Monday as a common first day of the week
    //   }
    //
    //   return firstDay;
    // }
    var openDateSelection = function(input) {
        if (width >= 1024) {
            window.parent.postMessage(JSON.stringify({
                height: 55
            }), "*");
        }
        if (startRef && endRef) {
            setActiveInput(input);
            setOpen(true);
        }
    };
    var onOpen = function(event, inst) {
        if (activeInput === "end") {
            inst.setActiveDate("end");
        } else {
            inst.setActiveDate("start");
        }
    };
    var rangeInputs = function() {
        return startRef && endRef && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
            theme: inputTheme,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()({
                    "flex w-full": viewMode === "horizontal",
                    "flex-col w-full": viewMode === "vertical"
                }),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()({
                            "mr-2 w-full": viewMode === "horizontal",
                            "mb-4": viewMode === "vertical"
                        }),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                error: error,
                                label: labelStart,
                                placeholder: labelStart,
                                inputProps: {
                                    autoComplete: "off"
                                },
                                value: valueRangeFormatted[0],
                                ref: startRef,
                                fullWidth: true,
                                onKeyDown: function(e) {
                                    e.preventDefault();
                                },
                                onClick: function() {
                                    return openDateSelection("start");
                                },
                                InputProps: {
                                    endAdornment: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_DateRange__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                        className: "cursor-pointer"
                                    })
                                },
                                InputLabelProps: {
                                    shrink: true
                                },
                                sx: {
                                    "& .MuiInputBase-input": {
                                        cursor: "pointer"
                                    }
                                }
                            }),
                            errorMessages && errorMessages.departure && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: (_FlightSearchDate_module_scss__WEBPACK_IMPORTED_MODULE_12___default().errorMessage),
                                children: errorMessages.departure
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()({
                            "w-full": viewMode === "horizontal"
                        }),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                error: error,
                                label: labelEnd,
                                placeholder: labelEnd,
                                inputProps: {
                                    autoComplete: "off",
                                    onClick: function() {
                                        return openDateSelection("end");
                                    }
                                },
                                value: valueRangeFormatted[1],
                                ref: endRef,
                                fullWidth: true,
                                onKeyDown: function(e) {
                                    e.preventDefault();
                                },
                                onClick: function() {
                                    return openDateSelection("end");
                                },
                                InputProps: {
                                    endAdornment: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_DateRange__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                        className: "cursor-pointer"
                                    })
                                },
                                InputLabelProps: {
                                    shrink: true
                                },
                                sx: {
                                    "& .MuiInputBase-input": {
                                        cursor: "pointer"
                                    }
                                }
                            }),
                            errorMessages && errorMessages.return && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: (_FlightSearchDate_module_scss__WEBPACK_IMPORTED_MODULE_12___default().errorMessage),
                                children: errorMessages.return
                            })
                        ]
                    })
                ]
            })
        });
    };
    var renderSingle = function() {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
            theme: inputTheme,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                inputProps: {
                    autoComplete: "off"
                },
                error: error,
                fullWidth: true,
                value: dateValueFormatted,
                label: labelStart,
                placeholder: labelStart,
                ref: singleRef,
                onClick: function() {
                    return setSingleOpen(true);
                },
                onKeyDown: function(e) {
                    e.preventDefault();
                },
                InputProps: {
                    endAdornment: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_DateRange__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {})
                },
                InputLabelProps: {
                    shrink: true
                }
            })
        });
    };
    var onChange = function(newValue) {
        if (newValue === null || newValue === void 0 ? void 0 : newValue.value.length) {
            setValueRange(newValue.value);
            if (newValue.value[0] && newValue.value[1]) {
                setValueRangeFormatted([
                    (0,date_fns__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(newValue.value[0], "E, dd MMM"),
                    (0,date_fns__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(newValue.value[1], "E, dd MMM"), 
                ]);
                setFieldValue(name, {
                    departure: newValue.value[0] && (0,date_fns__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(newValue.value[0], "yyyy-MM-dd"),
                    return: newValue.value[1] && (0,date_fns__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(newValue.value[1], "yyyy-MM-dd")
                });
            }
        }
    };
    var onChangeSingle = function(newValue) {
        if ((newValue === null || newValue === void 0 ? void 0 : newValue.value) && (0,date_fns__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(newValue.value)) {
            setDateValueFormatted((0,date_fns__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(newValue.value, "E, dd MMM"));
            setValue(newValue.value);
            setFieldValue(name, newValue.value && (0,date_fns__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(newValue.value, "yyyy-MM-dd"));
        }
    };
    var isMobileRange = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function() {
        return mode === "range" && width <= 1024;
    }, [
        mode,
        width
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "w-full",
        children: [
            mode === "range" ? rangeInputs() : renderSingle(),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                theme: pickerTheme,
                children: [
                    mode === "range" && width > 1024 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "relative",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mobiscroll_datepicker_react__WEBPACK_IMPORTED_MODULE_3__/* .Datepicker */ .aN, {
                            controls: [
                                "calendar"
                            ],
                            theme: "ios",
                            themeVariant: "light",
                            select: "range",
                            calendarType: "month",
                            renderCalendarHeader: rangeHeader,
                            firstDay: 1,
                            isOpen: open,
                            min: minDate,
                            rangeStartLabel: labelStart,
                            rangeEndLabel: labelEnd,
                            anchorAlign: "end",
                            max: maxDate,
                            maxRange: maxRange,
                            value: valueRange ? valueRange : [],
                            startInput: start,
                            endInput: end,
                            onClose: function() {
                                return setOpen(false);
                            },
                            onChange: function(newDate) {
                                return onChange(newDate);
                            },
                            onOpen: onOpen,
                            showInput: false,
                            rangeHighlight: true,
                            pages: 2
                        })
                    }),
                    isMobileRange() && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mobiscroll_datepicker_react__WEBPACK_IMPORTED_MODULE_3__/* .Datepicker */ .aN, {
                            controls: [
                                "calendar"
                            ],
                            theme: "ios",
                            themeVariant: "light",
                            select: "range",
                            renderCalendarHeader: rangeHeader,
                            isOpen: open,
                            firstDay: 1,
                            min: minDate,
                            max: maxDate,
                            maxRange: maxRange,
                            rangeStartLabel: labelStart,
                            rangeEndLabel: labelEnd,
                            value: valueRange ? valueRange : [],
                            startInput: start,
                            endInput: end,
                            onClose: function() {
                                return setOpen(false);
                            },
                            calendarScroll: "vertical",
                            touchUi: true,
                            onChange: function(newDate) {
                                return onChange(newDate);
                            },
                            onOpen: onOpen,
                            showInput: false,
                            buttons: [
                                "close"
                            ],
                            onCancel: function() {
                                return setOpen(false);
                            },
                            showOuterDays: true
                        })
                    }),
                    mode === "single" && width >= 1024 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "relative",
                        children: single && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mobiscroll_datepicker_react__WEBPACK_IMPORTED_MODULE_3__/* .Datepicker */ .aN, {
                            controls: [
                                "calendar"
                            ],
                            theme: "material",
                            themeVariant: "light",
                            selectMultiple: false,
                            anchor: single,
                            firstDay: firstDayOfTheWeek,
                            isOpen: singleOpen,
                            max: valueRange[0] && !valueRange[1] ? maxDate : null,
                            maxRange: maxRange,
                            min: allowPast ? null : minDate,
                            value: dateValue ? dateValue : minDate,
                            onClose: function() {
                                return setSingleOpen(false);
                            },
                            onChange: function(newDate) {
                                return onChangeSingle(newDate);
                            },
                            pages: 1,
                            showInput: false
                        })
                    }),
                    mode === "single" && width < 1024 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "relative",
                        children: single && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mobiscroll_datepicker_react__WEBPACK_IMPORTED_MODULE_3__/* .Datepicker */ .aN, {
                            controls: [
                                "calendar"
                            ],
                            theme: "material",
                            themeVariant: "light",
                            selectMultiple: false,
                            touchUi: true,
                            calendarScroll: "vertical",
                            isOpen: singleOpen,
                            firstDay: firstDayOfTheWeek,
                            showOuterDays: true,
                            max: valueRange[0] && !valueRange[1] ? maxDate : null,
                            maxRange: maxRange,
                            min: allowPast ? null : minDate,
                            value: dateValue ? dateValue : minDate,
                            onClose: function() {
                                return setSingleOpen(false);
                            },
                            onChange: function(newDate) {
                                return onChangeSingle(newDate);
                            },
                            pages: 1,
                            showInput: false
                        })
                    })
                ]
            })
        ]
    });
}, function(prevProps, nextProps) {
    var ref, ref1, ref2, ref3;
    // Return true to skip rendering, false to re-render
    // Skip re-render if the condition is met
    if (prevProps.error !== nextProps.error || prevProps.errorMessages !== nextProps.errorMessages || prevProps.value !== nextProps.value || prevProps.viewMode !== nextProps.viewMode || ((ref = prevProps.rangeValue) === null || ref === void 0 ? void 0 : ref[0]) !== ((ref1 = nextProps.rangeValue) === null || ref1 === void 0 ? void 0 : ref1[0]) || ((ref2 = prevProps.rangeValue) === null || ref2 === void 0 ? void 0 : ref2[1]) !== ((ref3 = nextProps.rangeValue) === null || ref3 === void 0 ? void 0 : ref3[1])) {
        return false;
    }
    return true;
});


/***/ }),

/***/ 81001:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ PersonInput; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(14251);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(52875);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(80969);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(69779);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(72276);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(68239);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(61903);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(30431);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(69417);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(22430);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(23926);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(87109);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(79350);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(78262);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _PersonInput_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(78456);
/* harmony import */ var _PersonInput_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_PersonInput_module_scss__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _mui_icons_material_Remove__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(94895);
/* harmony import */ var _mui_icons_material_ExpandMore__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(23508);
/* harmony import */ var _mui_icons_material_Add__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(96540);
/* harmony import */ var _react_hook_window_size__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(61715);














var PersonInput = function(param) {
    var name = param.name, setFieldValue = param.setFieldValue, multiModeHeading = param.multiModeHeading, multipleValue = param.multipleValue, value = param.value, _multiple = param.multiple, multiple = _multiple === void 0 ? false : _multiple, _disablePortal = param.disablePortal, disablePortal = _disablePortal === void 0 ? true : _disablePortal, _primaryColor = param.primaryColor, primaryColor = _primaryColor === void 0 ? "#00454A" : _primaryColor;
    var inputTheme = (0,_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        shape: {
            borderRadius: 12
        },
        palette: {
            primary: {
                main: primaryColor
            }
        },
        input: {
            style: {
                cursor: "pinter"
            }
        },
        typography: {
            fontFamily: '"Libre Franklin", sans-serif'
        }
    });
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(null), adults = ref[0], setAdults = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), dialogOpen = ref1[0], setDialogOpen = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(null), childrenAges = ref2[0], setChildrenAges = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(null), multiValue = ref3[0], setMultiValue = ref3[1];
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (value) {
            setAdults(value.adults);
            if (value.children) {
                setChildrenAges(value.children);
            }
        }
    }, [
        value
    ]);
    var width = (0,_react_hook_window_size__WEBPACK_IMPORTED_MODULE_4__/* .useWindowWidth */ .Lm)();
    var getForm = function(relative) {
        return multiple ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_PersonInput_module_scss__WEBPACK_IMPORTED_MODULE_5___default().personSelect), "font-libre", {
                relative: relative
            }),
            children: [
                multiValue === null || multiValue === void 0 ? void 0 : multiValue.map(function(value, multiIndex) {
                    var ref, ref1;
                    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react__WEBPACK_IMPORTED_MODULE_2__.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: (_PersonInput_module_scss__WEBPACK_IMPORTED_MODULE_5___default().multiModeHeading),
                                children: [
                                    multiModeHeading,
                                    " ",
                                    multiIndex + 1
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "flex flex-col items-stretch",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                children: "Adults:"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                                        size: "large",
                                                        color: "primary",
                                                        onClick: function() {
                                                            return removeAdult(true, multiIndex);
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_Remove__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                                                className: (_PersonInput_module_scss__WEBPACK_IMPORTED_MODULE_5___default().largeIcon),
                                                                fontSize: "large"
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_Remove__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                                                className: (_PersonInput_module_scss__WEBPACK_IMPORTED_MODULE_5___default().smallIcon),
                                                                fontSize: "medium"
                                                            })
                                                        ]
                                                    }),
                                                    multiValue[multiIndex].adults,
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                                        size: "large",
                                                        color: "primary",
                                                        onClick: function() {
                                                            return addAdult(true, multiIndex);
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_Add__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                                                className: (_PersonInput_module_scss__WEBPACK_IMPORTED_MODULE_5___default().largeIcon),
                                                                fontSize: "large"
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_Add__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                                                className: (_PersonInput_module_scss__WEBPACK_IMPORTED_MODULE_5___default().smallIcon),
                                                                fontSize: "medium"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                children: "Children:"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                                        size: "large",
                                                        color: "primary",
                                                        onClick: function() {
                                                            return removeChildren(true, multiIndex);
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_Remove__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                                                className: (_PersonInput_module_scss__WEBPACK_IMPORTED_MODULE_5___default().largeIcon),
                                                                fontSize: "large"
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_Remove__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                                                className: (_PersonInput_module_scss__WEBPACK_IMPORTED_MODULE_5___default().smallIcon),
                                                                fontSize: "medium"
                                                            })
                                                        ]
                                                    }),
                                                    (ref = multiValue[multiIndex].childrenAges) === null || ref === void 0 ? void 0 : ref.length,
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                                        size: "large",
                                                        color: "primary",
                                                        onClick: function() {
                                                            return addChildren(true, multiIndex);
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_Add__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                                                className: (_PersonInput_module_scss__WEBPACK_IMPORTED_MODULE_5___default().largeIcon),
                                                                fontSize: "large"
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_Add__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                                                className: (_PersonInput_module_scss__WEBPACK_IMPORTED_MODULE_5___default().smallIcon),
                                                                fontSize: "medium"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    !!((ref1 = multiValue[multiIndex].childrenAges) === null || ref1 === void 0 ? void 0 : ref1.length) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "flex flex-col mb-2",
                                        children: multiValue[multiIndex].childrenAges.map(function(childAge, index) {
                                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "flex justify-between w-full mt-1",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                        className: "flex",
                                                        children: [
                                                            "Age child ",
                                                            index + 1
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                                            select: true,
                                                            value: childAge !== null && childAge !== void 0 ? childAge : 0,
                                                            name: "childAge",
                                                            onChange: function(event) {
                                                                return applyChildAge(event, index, true, multiIndex);
                                                            },
                                                            SelectProps: {
                                                                native: width < 1024,
                                                                MenuProps: {
                                                                    disablePortal: false
                                                                }
                                                            },
                                                            children: Array.from(Array(18).keys()).map(function(i) {
                                                                return width < 1024 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                                                                    value: i,
                                                                    children: i
                                                                }, i) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                                                    sx: {
                                                                        textAlign: "center"
                                                                    },
                                                                    value: i,
                                                                    children: i
                                                                }, i);
                                                            })
                                                        })
                                                    })
                                                ]
                                            }, index);
                                        })
                                    }),
                                    !!multiIndex && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                        fullWidth: true,
                                        color: "primary",
                                        variant: "contained",
                                        className: "my-2",
                                        type: "button",
                                        onClick: function() {
                                            setMultiValue(multiValue.filter(function(_, index) {
                                                return index !== multiIndex;
                                            }));
                                        },
                                        children: [
                                            "Remove ",
                                            multiModeHeading
                                        ]
                                    })
                                ]
                            }, multiIndex)
                        ]
                    }, multiIndex);
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                    fullWidth: true,
                    className: "my-2",
                    color: "primary",
                    variant: "contained",
                    type: "button",
                    onClick: function() {
                        return setMultiValue((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(multiValue).concat([
                            {
                                adults: 1,
                                childrenAges: []
                            }
                        ]));
                    },
                    children: [
                        "ADD ",
                        multiModeHeading
                    ]
                }),
                width < 1024 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                    variant: "outlined",
                    className: "mt-2",
                    type: "button",
                    onClick: function() {
                        return setDialogOpen(false);
                    },
                    children: "OK"
                })
            ]
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_PersonInput_module_scss__WEBPACK_IMPORTED_MODULE_5___default().personSelect), "font-libre", {
                relative: relative
            }),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            children: "Adults:"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                    size: "large",
                                    color: "primary",
                                    onClick: function() {
                                        return removeAdult(false);
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_Remove__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                            className: (_PersonInput_module_scss__WEBPACK_IMPORTED_MODULE_5___default().largeIcon),
                                            fontSize: "large"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_Remove__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                            className: (_PersonInput_module_scss__WEBPACK_IMPORTED_MODULE_5___default().smallIcon),
                                            fontSize: "medium"
                                        })
                                    ]
                                }),
                                adults,
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                    size: "large",
                                    color: "primary",
                                    onClick: function() {
                                        return addAdult(false);
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_Add__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                            className: (_PersonInput_module_scss__WEBPACK_IMPORTED_MODULE_5___default().largeIcon),
                                            fontSize: "large"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_Add__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                            className: (_PersonInput_module_scss__WEBPACK_IMPORTED_MODULE_5___default().smallIcon),
                                            fontSize: "medium"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            children: "Children:"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                    size: "large",
                                    color: "primary",
                                    onClick: function() {
                                        return removeChildren(false);
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_Remove__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                            className: (_PersonInput_module_scss__WEBPACK_IMPORTED_MODULE_5___default().largeIcon),
                                            fontSize: "large"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_Remove__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                            className: (_PersonInput_module_scss__WEBPACK_IMPORTED_MODULE_5___default().smallIcon),
                                            fontSize: "medium"
                                        })
                                    ]
                                }),
                                (childrenAges === null || childrenAges === void 0 ? void 0 : childrenAges.length) || 0,
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                    size: "large",
                                    color: "primary",
                                    onClick: function() {
                                        return addChildren(false);
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_Add__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                            className: (_PersonInput_module_scss__WEBPACK_IMPORTED_MODULE_5___default().largeIcon),
                                            fontSize: "large"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_Add__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                            className: (_PersonInput_module_scss__WEBPACK_IMPORTED_MODULE_5___default().smallIcon),
                                            fontSize: "medium"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "flex flex-col",
                    children: !!(childrenAges === null || childrenAges === void 0 ? void 0 : childrenAges.length) && childrenAges.map(function(childAge, index) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "flex justify-between w-full mt-1",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                    className: "flex",
                                    children: [
                                        "Age child ",
                                        index + 1
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                        select: true,
                                        value: childAge !== null && childAge !== void 0 ? childAge : 0,
                                        onChange: function(event) {
                                            return applyChildAge(event, index);
                                        },
                                        SelectProps: {
                                            MenuProps: {
                                                disablePortal: false
                                            }
                                        },
                                        children: Array.from(Array(18).keys()).map(function(i) {
                                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                                sx: {
                                                    textAlign: "center"
                                                },
                                                value: i,
                                                children: i
                                            }, i);
                                        })
                                    })
                                })
                            ]
                        }, index);
                    })
                }),
                width < 1024 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                    variant: "outlined",
                    className: "mt-2",
                    type: "button",
                    onClick: function() {
                        return setDialogOpen(false);
                    },
                    children: "OK"
                })
            ]
        });
    };
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (childrenAges && adults) {
            setFieldValue("".concat(name), {
                adults: adults,
                children: childrenAges
            });
        }
    }, [
        childrenAges,
        adults
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (multiValue) {
            setFieldValue("".concat(name), multiValue);
        }
    }, [
        multiValue
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (multipleValue === null || multipleValue === void 0 ? void 0 : multipleValue.length) {
            setMultiValue(multipleValue);
        }
    }, [
        multipleValue
    ]);
    var ref4 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_2__.useState(null), 2), anchorEl = ref4[0], setAnchorEl = ref4[1];
    var handleClick = function(event) {
        if (event) {
            width > 1024 ? setAnchorEl(anchorEl ? null : event.currentTarget) : setDialogOpen(!dialogOpen);
            event.preventDefault();
            window.parent.postMessage(JSON.stringify({
                height: 400
            }), "*");
        } else {
            setAnchorEl(null);
        }
    };
    var open = Boolean(anchorEl);
    var id = open ? "simple-popper" : undefined;
    var addAdult = function() {
        var multiMode = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false, index = arguments.length > 1 ? arguments[1] : void 0;
        var ref;
        if (!multiMode && adults + ((ref = childrenAges === null || childrenAges === void 0 ? void 0 : childrenAges.length) !== null && ref !== void 0 ? ref : 0) < 9) {
            setAdults(+adults + 1);
        }
        var ref1;
        if (multiMode && adults + ((ref1 = childrenAges === null || childrenAges === void 0 ? void 0 : childrenAges.length) !== null && ref1 !== void 0 ? ref1 : 0) < 9) {
            var updated = multiValue.map(function(entry, i) {
                return i === index ? (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)({}, entry), {
                    adults: +entry.adults + 1
                }) : entry;
            });
            setMultiValue(updated);
        }
    };
    var removeAdult = function() {
        var multiMode = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false, index = arguments.length > 1 ? arguments[1] : void 0;
        if (!multiMode && adults > 1) {
            setAdults(+adults - 1);
        }
        if (multiMode && multiValue[index].adults > 1) {
            var updated = multiValue.map(function(entry, i) {
                return i === index ? (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)({}, entry), {
                    adults: entry.adults - 1
                }) : entry;
            });
            setMultiValue(updated);
        }
    };
    var addChildren = function() {
        var multiMode = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false, index = arguments.length > 1 ? arguments[1] : void 0;
        var ref;
        if (!multiMode && adults + ((ref = childrenAges === null || childrenAges === void 0 ? void 0 : childrenAges.length) !== null && ref !== void 0 ? ref : 0) < 9) {
            appendChildrenAgeSelection();
        }
        var ref1;
        if (multiMode && adults + ((ref1 = childrenAges === null || childrenAges === void 0 ? void 0 : childrenAges.length) !== null && ref1 !== void 0 ? ref1 : 0) < 9) {
            appendChildrenAgeSelection(true, index);
        }
    };
    var removeChildren = function() {
        var multiMode = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false, index = arguments.length > 1 ? arguments[1] : void 0;
        var ref;
        if (!multiMode && (childrenAges === null || childrenAges === void 0 ? void 0 : childrenAges.length)) {
            removeChildAgeSelection();
        }
        if (multiMode && ((ref = multiValue[index]) === null || ref === void 0 ? void 0 : ref.childrenAges.length)) {
            removeChildAgeSelection(true, index);
        }
    };
    var appendChildrenAgeSelection = function() {
        var multiMode = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false, index = arguments.length > 1 ? arguments[1] : void 0;
        if (!multiMode) {
            setChildrenAges((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(childrenAges || []).concat([
                0
            ]));
        } else {
            var updated = multiValue.map(function(item, i) {
                return i === index ? (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)({}, item), {
                    childrenAges: (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(item.childrenAges || []).concat([
                        0
                    ])
                }) : item;
            });
            setMultiValue(updated);
        }
    };
    var removeChildAgeSelection = function() {
        var multiMode = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false, index = arguments.length > 1 ? arguments[1] : void 0;
        if (!multiMode) {
            setChildrenAges(function(prev) {
                return prev ? prev.slice(0, -1) : [];
            });
        } else {
            var updated = multiValue.map(function(item, i) {
                return i === index ? (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)({}, item), {
                    childrenAges: item.childrenAges ? item.childrenAges.slice(0, -1) : []
                }) : item;
            });
            setMultiValue(updated);
        }
    };
    var applyChildAge = function(event, index) {
        var multiMode = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, multiIndex = arguments.length > 3 ? arguments[3] : void 0;
        if (!multiMode) {
            var updatedChildrenAges = childrenAges.map(function(age, i) {
                return i === index ? event.target.value : age;
            });
            setChildrenAges(updatedChildrenAges);
        } else {
            var updated = multiValue.map(function(item, i) {
                return i === multiIndex ? (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)({}, item), {
                    childrenAges: item.childrenAges.map(function(age, j) {
                        return j === index ? event.target.value : age;
                    })
                }) : item;
            });
            setMultiValue(updated);
        }
    };
    var calculateAdults = function() {
        return multiValue ? multiValue.reduce(function(prev, curr) {
            return prev + +curr.adults;
        }, 0) : 0;
    };
    var calculateChildren = function() {
        return multiValue ? multiValue.reduce(function(prev, curr) {
            return prev + curr.childrenAges.length;
        }, 0) : 0;
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
        theme: inputTheme,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_17__/* .ClickAwayListener */ .d, {
            onClickAway: function(evt) {
                if (evt.target.name !== name && evt.target.tagName !== "BODY") {
                    handleClick();
                }
            },
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "w-full",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                        fullWidth: true,
                        value: multiple ? "".concat(multiValue === null || multiValue === void 0 ? void 0 : multiValue.length, " ").concat(multiModeHeading).concat((multiValue === null || multiValue === void 0 ? void 0 : multiValue.length) > 1 ? "s" : "", " (").concat(calculateAdults(), " ").concat(calculateAdults() > 1 ? "Adults" : "Adult").concat(calculateChildren() > 0 ? ", " + calculateChildren() : "", " ").concat(calculateChildren() <= 0 ? "" : calculateChildren() > 1 ? "Children" : "Child", ")") : "".concat(((childrenAges === null || childrenAges === void 0 ? void 0 : childrenAges.length) || 0) + adults, " Person").concat(((childrenAges === null || childrenAges === void 0 ? void 0 : childrenAges.length) || 0) + adults >= 2 ? "s" : ""),
                        className: (_PersonInput_module_scss__WEBPACK_IMPORTED_MODULE_5___default().personInput),
                        onClick: handleClick,
                        InputProps: {
                            endAdornment: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                position: "end",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_ExpandMore__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {})
                            })
                        },
                        label: "Passengers",
                        name: name,
                        "aria-describedby": id
                    }),
                    width > 1024 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {
                        style: {
                            zIndex: 100
                        },
                        disablePortal: disablePortal,
                        id: id,
                        open: open,
                        anchorEl: anchorEl,
                        placement: "bottom-start",
                        children: getForm(false)
                    }),
                    width <= 1024 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z, {
                        open: dialogOpen,
                        fullWidth: true,
                        onBackdropClick: function() {
                            return setDialogOpen(false);
                        },
                        children: getForm(true)
                    })
                ]
            })
        })
    });
};


/***/ }),

/***/ 63110:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"nice-dates-navigation":"FlightSearchDate_nice-dates-navigation__qgGTm","nice-dates-day":"FlightSearchDate_nice-dates-day__uKdHE","nice-dates-popover":"FlightSearchDate_nice-dates-popover__mJCSa","rangeContainer":"FlightSearchDate_rangeContainer__J2kHx","MuiOutlinedInput-root":"FlightSearchDate_MuiOutlinedInput-root__s0Nq8","errorMessage":"FlightSearchDate_errorMessage__Zd77q","closeDialog":"FlightSearchDate_closeDialog___iJMa"};

/***/ }),

/***/ 78456:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"personSelect":"PersonInput_personSelect__siARo","multiModeHeading":"PersonInput_multiModeHeading__2Jo4f","personInput":"PersonInput_personInput__0D4Il","MuiOutlinedInput-input":"PersonInput_MuiOutlinedInput-input__o94gA","largeIcon":"PersonInput_largeIcon__y2P_z","smallIcon":"PersonInput_smallIcon__EESV_"};

/***/ })

}]);